<div class="modal">
    <div class="modal-ctn">
  
      <div class="options">
        <div>{{ 'PARTICIPANT.NEW' | translate | uppercase }}</div>
        <img src="assets/images/close.svg" (click)="close()"/>
      </div>
  
      <form [formGroup]="form">
        <div>
          <label>{{ 'PARTICIPANT.FIRST_NAME' | translate }}</label>
          <input type="text" formControlName="firstName">
        </div>
        <div>
          <label>{{ 'PARTICIPANT.LAST_NAME' | translate }}</label>
          <input type="text" formControlName="lastName">
        </div>
        <div>
          <label>{{ 'PARTICIPANT.EMAIL' | translate }}</label>
          <input type="text" formControlName="email">
        </div>
        <!-- <div>
          <label>{{ 'PARTICIPANT.FUNCTION' | translate }}</label>
          <select formControlName="role">
              <ng-container *ngFor="let f of refineryparticipantfunctions">
                  <option value="{{ f.refineryparticipantfunctionpk }}">{{ f.refineryparticipantfunction }}</option>ça j'en doute pas
              </ng-container>
          </select>
        </div>  -->
      </form>
  
      <div class="footer">
        <button (click)="close()" class="cancel">{{ 'CLOSE' | translate }}</button>
        <button (click)="create()" [disabled]="form.invalid">{{ 'CREATE' | translate }}</button>
      </div>        
    </div>
  </div>